import React from 'react'
import './Contact.css'

function Contact() {
  return (
    <section className='contact' id='contact'>

      {/* Dot grid decoration */}
      <div className='contact-dots contact-dots--top'></div>
      <div className='contact-dots contact-dots--bottom'></div>

      {/* Pink glow orb */}
      <div className='contact-orb'></div>

      {/* Left — Big headings */}
      <div className='contact-left'>
        <h2 className='contact-heading'>
          <span>Get in</span>
          <span>touch.</span>
        </h2>
        <h2 className='contact-heading contact-heading--sub'>
          <span>Start a</span>
          <span>conversation.</span>
        </h2>
      </div>

      {/* Right — Contact details */}
      <div className='contact-right'>

        <div className='contact-item'>
          <div className='contact-item-icon'>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
          </div>
          <div className='contact-item-body'>
            <strong>Address</strong>
            <span>Nairobi, Kenya</span>
            <span>RastegHub HQ</span>
          </div>
        </div>

        <div className='contact-item'>
          <div className='contact-item-icon'>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.61 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.59a16 16 0 0 0 6 6l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
          </div>
          <div className='contact-item-body'>
            <strong>Phone</strong>
            <a href='tel:+254739224458'>+254 739 224 458</a>
          </div>
        </div>

        <div className='contact-item'>
          <div className='contact-item-icon'>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"/>
              <polyline points="22,4 12,13 2,4"/>
            </svg>
          </div>
          <div className='contact-item-body'>
            <strong>Mail</strong>
            <a href='mailto:hello@rasteghub.co.ke'>hello@rasteghub.co.ke</a>
          </div>
        </div>

        <div className='contact-item'>
          <div className='contact-item-icon'>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>
              <path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
            </svg>
          </div>
          <div className='contact-item-body'>
            <strong>Follow Us</strong>
            <div className='contact-socials'>
              <a href='https://www.linkedin.com/company/rasteghub' target='_blank' rel='noopener noreferrer' className='social-pill' aria-label='LinkedIn'>in</a>
              <a href='https://www.instagram.com/ra_steg_hub?igsh=MXQwbW1xOWl2bnVjcg==' target='_blank' rel='noopener noreferrer' className='social-pill' aria-label='Instagram'>ig</a>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default Contact